var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { inject, observer } from 'mobx-react';
import { Stack } from '@mui/material';
// import CodeEditor, { SelectionText } from "@uiw/react-textarea-code-editor";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-tomorrow";
import "ace-builds/src-noconflict/ext-language_tools";
var CustomCssEditor = /** @class */ (function (_super) {
    __extends(CustomCssEditor, _super);
    function CustomCssEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    Object.defineProperty(CustomCssEditor.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            return (_jsx(Stack, __assign({ direction: "column", spacing: 2, className: "case-types-tab-panel" }, { children: _jsx(Stack, __assign({ direction: "row", spacing: 2 }, { children: _jsx(AceEditor, { mode: "css", theme: "tomorrow", value: caseType === null || caseType === void 0 ? void 0 : caseType.customCss, onChange: function (evn) { return _this.setCss(evn); }, editorProps: { $blockScrolling: true }, showPrintMargin: true, showGutter: true, highlightActiveLine: true, setOptions: {
                            enableBasicAutocompletion: true,
                            enableLiveAutocompletion: false,
                            enableSnippets: false,
                            showLineNumbers: true,
                            tabSize: 2,
                        }, width: "100%", height: "750px", minLines: 3 }, void 0) }), void 0) }), void 0));
        }
    });
    Object.defineProperty(CustomCssEditor.prototype, "setCss", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (cssCode) {
            var _a, _b;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (caseType) {
                var updatedCaseType = __assign(__assign({}, caseType), { customCss: cssCode });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    CustomCssEditor = __decorate([
        inject('caseTypesStore'),
        inject('languageStore'),
        observer
    ], CustomCssEditor);
    return CustomCssEditor;
}(React.Component));
export default CustomCssEditor;
